window.UX = {};
export default UX;